import { SubTitleWithImage } from "@stories/atoms/SubTitle/SubTitle";
import * as RouteHelper from "@utils/routes";
import { PageBreadcrumbs } from "@stories/atoms/PageBreadcrumbs/PageBreadcrumbs";
import { useProjectContext } from "@hooks/context/useProjectContext";
import { useProfileContext } from "@hooks/context/useProfileContext";
import { useReport } from "@hooks/crud/useReports";
import { ProjectLoader } from "@stories/atoms/Loaders/ProjectLoader/ProjectLoader";
import { Card, Grid, useTheme } from "@mui/material";
import { gridSpacing } from "constant";
import { ReportTable } from "@stories/molecules/ReportTable/ReportTable";

export const Reports = () => {
  const theme = useTheme();

  const { userProfile, userOrganisation } = useProfileContext();

  const { selectedProject, selectedProjectOrganisation } = useProjectContext();

  const { reports, isReportLoading } = useReport(selectedProject.id);

  if (!userProfile || !userOrganisation) {
    return <ProjectLoader />;
  }

  const breadcrumbs = [
    {
      path: RouteHelper.contractorReports(selectedProject.id),
      name: `${selectedProject.projectName} Reports`,
    },
  ];

  reports.sort((a, b) => {
    if (a.contractorId !== b.contractorId) {
      return a.contractorId === userOrganisation.id ? -1 : 1;
    }
    const aDate = new Date(
      a.dueDateYear,
      a.dueDateMonth,
      selectedProject.reportingDueDate
    );
    const bDate = new Date(
      b.dueDateYear,
      b.dueDateMonth,
      selectedProject.reportingDueDate
    );
    return aDate.getTime() - bDate.getTime();
  });
  return (
    <>
      <PageBreadcrumbs
        title={`${selectedProject.projectName} Reports`}
        organisationLogo={selectedProjectOrganisation.organisationLogo}
        links={breadcrumbs}
      />

      <ReportTable
        loading={isReportLoading}
        project={selectedProject}
        reports={reports}
      />
    </>
  );
};
